import { render, staticRenderFns } from "./ProfessionalsList.vue?vue&type=template&id=ecd6bfa8&scoped=true&"
import script from "./ProfessionalsList.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsList.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalsList.vue?vue&type=style&index=0&id=ecd6bfa8&lang=scss&scoped=true&"
import style1 from "./ProfessionalsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd6bfa8",
  null
  
)

export default component.exports